import React from "react";
import { Link } from "gatsby"
import { capitalize } from "lodash";
import { defaultArea, defaultArea_Slug, country, PopularSearch_Areas } from "../../../../common/constant"
import { PropertySearchUrl } from "../../../../common/utils/property_utils"
import { PageLinks } from "../../../../common/page-links";

const PropertyBedrooms = ({searchParams, property_type_list}) => {

    //console.log("searchParams_areas", searchParams.areas);


    var area = searchParams.areas ? (searchParams.areas === defaultArea.toLowerCase() ? country : searchParams.areas.replace(/"/g, "")) : country;

    if(area.length < 5){
        area = area.toUpperCase();
    } else {
        area = capitalize(area);
    }

    var area_slug = searchParams.areas ? searchParams.areas : defaultArea_Slug;

    area_slug = (area_slug.replace(/ /g, '-')).toLowerCase();


    var property_url = PropertySearchUrl(searchParams.department, searchParams.search_type)

    var property_text = "Property";
    var bedroom_url = `${property_url}in-${area_slug}`;

    if(searchParams.department === "commercial"){
        property_text = "Commercial property";
    }

    if(searchParams.bedrooms && searchParams.propertyType){
        //property_text = property_text;

        property_text = searchParams.propertyType;

        var filter_prop_type = searchParams.propertyType ? (property_type_list?.length > 0 && property_type_list.filter(item => item.value === searchParams.propertyType)) : "";
        if(filter_prop_type?.length > 0){
            property_text = filter_prop_type[0].label.replace(/\//g,' and ');
        }

    } else if(searchParams.department === "commercial" && searchParams.propertyType){
        property_text = property_text;

    } else if(searchParams.propertyType){
        property_text = searchParams.propertyType;

        var filter_prop_type = searchParams.propertyType ? (property_type_list?.length > 0 && property_type_list.filter(item => item.value === searchParams.propertyType)) : "";
        if(filter_prop_type?.length > 0){
            property_text = filter_prop_type[0].label.replace(/\//g,' and ');
        }
        
        bedroom_url = `${property_url}in-${area_slug}/type-${searchParams.propertyType}`
    }

    //console.log("searchParams ==>", searchParams, area_slug, bedroom_url)

    const BedroomLinks = ({bedroom_url, searchParams, property_text, area}) =>{
        return(
            <ul>
                <li><Link to={`${bedroom_url}/1-and-more-bedrooms/`}>1 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
                <li><Link to={`${bedroom_url}/2-and-more-bedrooms/`}>2 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
                <li><Link to={`${bedroom_url}/3-and-more-bedrooms/`}>3 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
                <li><Link to={`${bedroom_url}/4-and-more-bedrooms/`}>4 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
            </ul>
        )
    }

    const PropertyTypeLinks = ({property_url, property_text, searchParams, item}) =>{
        return(
            <li><Link to={`${property_url}in-${item.value}/`}>{property_text} {searchParams.action} in {item.label}</Link></li>
        )
    }
    

    return (<>
        {searchParams.department === "commercial" ? 
            (searchParams.propertyType ?
                <ul>
                    {PopularSearch_Areas.map((item) => {      
                        return(
                            // <li><Link to={`${property_url}in-${item.value}/`}>{property_text} {searchParams.action} in {item.label}</Link></li>

                            <PropertyTypeLinks property_url={property_url} item={item} property_text={property_text} searchParams={searchParams}/>
                        )
                    })      
                    }
                </ul>            
                :
                <ul>
                    <li><Link to={`${bedroom_url}/type-office/`}>Offices {searchParams.action} in {area}</Link></li>
                    <li><Link to={`/${PageLinks.landlords}/`}>Property services in {area}</Link></li>
                    <li><Link to={`/${PageLinks.branch_finder}/`}>Estate agents  in {area}</Link></li>
                    <li><Link to={`/${PageLinks.request_valuation}/`}>Property valuation in {area}</Link></li>
                </ul>
            )
        :
            // <ul>
            //     <li><Link to={`${bedroom_url}/1-and-more-bedrooms/`}>1 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
            //     <li><Link to={`${bedroom_url}/2-and-more-bedrooms/`}>2 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
            //     <li><Link to={`${bedroom_url}/3-and-more-bedrooms/`}>3 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
            //     <li><Link to={`${bedroom_url}/4-and-more-bedrooms/`}>4 bedroom {property_text.toLowerCase()} {searchParams.action} in {area}</Link></li>
            // </ul>
            <BedroomLinks bedroom_url={bedroom_url} searchParams={searchParams} property_text={property_text} area={area} />
        }
    </>)
}
export default PropertyBedrooms;